// @flow

import React, { useState } from 'react';
import styled, { css } from 'styled-components';

import type { ImageToWebPFragment } from 'graphql-types';
import { absolute } from 'styles';

const Wrapper = styled.div`
  width: 100%;
  ${props =>
    props.fitContainer &&
    css`
      ${absolute()}
    `};

  > div {
    position: relative;
    ${props =>
      props.fitContainer
        ? css`
            ${absolute()};
          `
        : css`
            width: 100%;
            height: 0;
            padding-top: calc(${props => 100 / props.aspectRatio}%);
          `}

    img {
      object-fit: cover;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      pointer-events: none;
    }

    ${props =>
      props.fitContainer &&
      css`
        picture {
          ${absolute()};
        }
        img {
          height: 100%;
          width: 100%;
        }
      `};
  }
`;

const BlurImage = styled.img`
  transition: opacity 300ms linear;
  opacity: ${props => (props.visible ? 1 : 0)};
`;

const RealImage = styled.picture`
  transition: ${({ overrideLoading }) => (overrideLoading ? 'none' : 'opacity 1000ms ease')};
  opacity: ${props => (props.visible ? 1 : 0)};
`;

const WebPLoader = (props: {
  visible: boolean,
  alt?: string,
  fitContainer?: boolean,
  overrideLoading: boolean,
  image: ImageToWebPFragment,
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const {
    visible,
    fitContainer,
    overrideLoading,
    image: {
      childImageSharp: { originalWebp, original },
    },
    alt = '',
  } = props;
  return (
    <Wrapper fitContainer={fitContainer} aspectRatio={original.aspectRatio}>
      <div>
        {!overrideLoading && <BlurImage src={original.base64} aria-hidden="true" alt={alt} visible={!imageLoaded} />}
        {(overrideLoading || visible) && (
          <RealImage onLoad={() => setImageLoaded(true)} visible={overrideLoading || imageLoaded} overrideLoading={overrideLoading}>
            <source srcSet={originalWebp.src} type="image/webp" />
            <img src={original.src} alt={alt} role={alt ? null : 'presentation'} />
          </RealImage>
        )}
      </div>
    </Wrapper>
  );
};

export default WebPLoader;
